import logo from "../img/logo.png";

// import "./LogIn.css";

const Loading = () => {
  return (
    <div>
      <img className="welcome-image" alt="Logo" src={logo}></img>
    </div>
  );
};

export default Loading;
